module.exports = __webpack_public_path__ + "img/sticker-nye-loverfans-es.e10fcb71.svg";